var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('div',{staticClass:"lite-profile-tile-wrapper"},[_c('PlayerStatTile',{attrs:{"stat-name":this.heightStatTile.label,"stat-value":this.heightStatTile.value,"thumbnail-image":this.heightStatTile.imageUrl,"video":this.heightStatTile.video}})],1),_vm._v(" "),_c('LiteProfileBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }